<!--首页-->
<template>
  <div class="home-container">
    <headerIndex/>
    <div class="home-top" v-if="showTop">
      <div class="top-content">
        <p class="SourceHanSansCN">{{ cityList.name }}企业服务网</p>
        <el-input placeholder="请输入搜索内容" v-model="keyword" class="input-with-select" @keyup.enter.native="onSearch"
                  style="width: 45%;margin-top: 65px;">
          <template slot="prefix">
            <i slot="prefix" class="el-icon-search"/>
          </template>
          <el-button type="danger" slot="append" @click="onSearch">搜一下</el-button>
        </el-input>
      </div>
    </div>
    <div class="search-menu" v-else>
      <div class="logo"></div>
      <span class="title-logo">全国企业服务网</span>
      <el-input placeholder="请输入搜索内容" v-model="keyword" class="input-with-select" style="width: 30%;margin-left: 45px">
        <template slot="prefix">
          <i slot="prefix" class="el-icon-search"/>
        </template>
        <el-button type="danger" slot="append" @click="onSearch">搜一下</el-button>
      </el-input>
    </div>
    <div :class="tabClass">
      <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="0">关注</el-menu-item>
        <el-menu-item index="2">推荐</el-menu-item>
        <el-menu-item v-for="item of mine_channel" :index="item.nid">{{ item.name }}</el-menu-item>
        <el-menu-item index="-1">企业服务</el-menu-item>
        <!--<el-menu-item index="15">
          <el-popover placement="bottom-end" title="" style="width: 56vw;" popper-class="popper"
                      v-model="visible_popover">
            <div>
              <p>我的频道</p>
              <el-button round v-for="channel of mine_channel" @click="changeChannel(channel.nid)">{{ channel.name }}
              </el-button>
            </div>
            <div>
              <p>省级节点</p>
              <el-button round v-for="citys of cityJson" @click="changeCity(citys)">{{ citys.name }}</el-button>
            </div>
            <span slot="reference">更多</span>
          </el-popover>
        </el-menu-item>-->
      </el-menu>
    </div>
    <div class="home-info" :style="'min-height:'+min_heights+'px;'"
         v-if="activeIndex!=91 && activeIndex!=0 && activeIndex!=100 && activeIndex!=101">
      <defaultInfo :activeIndex="activeIndex" :cityList="cityList" :activeTabs="activeTabs"/>
    </div>
    <div class="home-info" :style="'min-height:'+min_heights+'px;'" v-else-if="activeIndex==0">
      <follow-info :activeIndex="activeIndex" :cityList="cityList" :activeTabs="activeTabs"/>
    </div>
    <div class="home-info" :style="'min-height:'+min_heights+'px;'" v-else-if="activeIndex==100">
      <official-no :activeIndex="activeIndex" :cityList="cityList" :activeTabs="activeTabs"/>
    </div>
    <div class="home-info" :style="'min-height:'+min_heights+'px;'" v-else-if="activeIndex==101">
      <bidding :activeIndex="activeIndex" :cityList="cityList" :activeTabs="activeTabs"/>
    </div>
    <div class="home-info" :style="'min-height:'+min_heights+'px;'" v-else>
      <videoInfo/>
    </div>
    <hang/>
    <homefooter/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import homefooter from '@/components/footer/home_footer';
import defaultInfo from "@/views/home/defaultInfo";
import videoInfo from "@/views/home/videoInfo";
import Hang from "@/components/Hang/Hang";
import {headlines, getCityInfo} from '@/api/interfaceApi'
import FollowInfo from "@/views/home/followInfo";
import OfficialNo from "@/views/home/officialNo";
import Bidding from "@/views/home/bidding";
import $store from "@/store";
import cityJson from '@/static/cityJson.json'
import {serviceNode} from "@/api/cloudServiceApi";

export default {
  name: "index",
  components: {Bidding, OfficialNo, FollowInfo, headerIndex, homefooter, defaultInfo, videoInfo, Hang},
  data() {
    return {
      keyword: '',
      mine_channel: [],
      /*省级节点*/
      cityJson: cityJson,
      visible_popover: false,
      cityList: {
        id: 500000,
        lat: 29.563707,
        level: 1,
        lng: 106.550483,
        name: "重庆",
        pid: 0,
        short_name: "重庆",
        prefix: 'cq',
        abridge: '渝'
      },
      tabClass: 'home-content',
      showTop: true,
      activeTabs: {},
      activeIndex: '2',
      min_heights: document.documentElement.clientHeight - 663,
      pinyinItem: [
        {type: 'beijing', name: '京'},
        {type: 'tianjin', name: '津'},
        {type: 'hebei', name: '冀'},
        {type: 'shanxi', name: '晋'},
        {type: 'neimenggu', name: '蒙'},
        {type: 'liaoning', name: '辽'},
        {type: 'jilin', name: '吉'},
        {type: 'heilongjiang', name: '黑'},
        {type: 'shanghai', name: '沪'},
        {type: 'jiangsu', name: '苏'},
        {type: 'zhejiang', name: '浙'},
        {type: 'fujian', name: '闽'},
        {type: 'jiangxi', name: '赣'},
        {type: 'shandong', name: '鲁'},
        {type: 'henan', name: '豫'},
        {type: 'hubei', name: '鄂'},
        {type: 'hunan', name: '湘'},
        {type: 'guangdong', name: '粤'},
        {type: 'guangxi', name: '桂'},
        {type: 'hainan', name: '琼'},
        {type: 'chongqing', name: '渝'},
        {type: 'sichuan', name: '川'},
        {type: 'guizhou', name: '黔'},
        {type: 'yunnan', name: '滇'},
        {type: 'xizang', name: '藏'},
        {type: 'shaanxi', name: '陕'},
        {type: 'gansu', name: '甘'},
        {type: 'qinghai', name: '青'},
        {type: 'ningxia', name: '宁'},
        {type: 'xinjiang', name: '新'},
        {type: 'anhui', name: '皖'},
      ]
    }
  },
  computed: {
    childNode() {
      return $store.state.childNode
    },
    childNodes() {
      return $store.state.childNodes
    }
  },
  methods: {
    handleSelect(key) {
      this.activeIndex = key;
      for (let active of this.mine_channel) {
        if (key == active.nid) {
          this.activeTabs = active;
        }
      }
      if (key == '-1') {
        this.$router.push({
          path: '/ServiceCentre/serviceCloud',
          query: {pName: this.cityList.abridge + '企服务云'}
        })
      }
    },
    /*选择频道*/
    changeChannel(index) {
      this.activeIndex = index;
      this.visible_popover = false
    },
    changeCity(list) {
      for (let tabs of this.mine_channel) {
        if (tabs.nid == '96') {
          tabs.name = JSON.parse(list).name;
          tabs.no = JSON.parse(list).cityCode;
        }
      }
    },
    /*跳转搜索界面*/
    onSearch() {
      this.$router.replace({
        path: '/search',
        query: {
          keyword: this.keyword
        }
      })
    },
    /*获取用户数据分类*/
    getHeadlines() {
      headlines({location: this.cityList.name}).then(res => {
        if (res.code == 200) {
          this.mine_channel = JSON.parse(JSON.stringify(res.content.list_have));
          for (let mine of this.mine_channel) {
            if (mine.nid == 1) {
              mine.name = this.cityList.abridge + '商';
            }
            if (mine.nid == 96) {
              if (this.childNode) {
                mine.name = this.childNode.name;
                mine.no = this.childNode.cityCode;
              }
            }
            mine.nid = mine.nid.toString();
          }
        }
      })
    },
    /**获取地图定位*/
    getMapArea() {
      const that = this;
      let url = window.location.href;
      // url = 'http://beijing.bangqichat.com'
      if (url.indexOf('www') > -1) {
        let str = url.split('://www.')
        let str1 = str[1].split('.');
        let pinyin = str1[0];
        for (let a = 0; a < this.pinyinItem.length; a++) {
          if (this.pinyinItem[a].type == pinyin) {
            for (let li of cityJson) {
              if (this.pinyinItem[a].name == li.abridge) {
                this.cityList = li;
                document.title = li.abridge+'企服务云';
                if (!sessionStorage.getItem('locationInfo')) {
                  that.getCityCode(li.lng, li.lat);
                } else {
                  this.getHeadlines();
                }
              }
            }
          }
        }
      } else {
        let str = url.split('://')
        let str1 = str[1].split('.');
        let pinyin = str1[0];
        for (let a = 0; a < this.pinyinItem.length; a++) {
          if (this.pinyinItem[a].type == pinyin) {
            for (let li of cityJson) {
              if (this.pinyinItem[a].name == li.abridge) {
                this.cityList = li;
                document.title = li.abridge+'企服务云';
                if (!sessionStorage.getItem('locationInfo')) {
                  that.getCityCode(li.lng, li.lat);
                } else {
                  this.getHeadlines();
                }
              }
            }
          }
        }
      }
    },
    getCityCode(lat, lng) {
      getCityInfo(lat, lng, 1).then(res => {
        $store.state.locationInfo = res.content;
        this.cityInfo = res.content;
        sessionStorage.setItem("locationInfo", JSON.stringify(res.content));
        localStorage.setItem("locationInfo", JSON.stringify(res.content));
        serviceNode({cityCode: res.content.id, request: 'form', uid: 0}).then(obj => {
          if (obj.code == 200) {
            $store.commit('SET_ChildNodes', JSON.stringify(obj.content.list));
            for (let a = 0; a < obj.content.list.length; a++) {
              if (a == 0) {
                $store.commit('SET_CHILD_NODE', JSON.stringify(obj.content.list[0]));
              }
            }
            this.getHeadlines();
          }
        })
      })
    },
  },
  beforeMount() {
    this.getMapArea();
    if (sessionStorage.getItem('setPositioning'))
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    else if (sessionStorage.getItem('locationInfo')) {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
  }
}
</script>
<style scoped>
.home-container >>> .home-top .el-input__inner {
  background-color: #F1F1F1;
  border-radius: 8px 0px 0px 8px;
  border: 1px solid white;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 50px;
}

.home-container >>> .search-menu .el-input__inner {
  background-color: #ffffff;
  border-radius: 8px 0px 0px 8px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 50px;
  border-right: none;
}

.home-container >>> input::-webkit-input-placeholder {
  color: #AAAAAA;
}

.home-container >>> .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}

.home-container >>> .el-icon-search {
  font-size: 19px;
}

.home-container >>> .el-input__prefix {
  left: 20px;
  color: #666666;
  font-size: 33px;
}

.home-container >>> .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 0px 8px 8px 0px;
  padding: 0 32px;
}

.home-container >>> .el-menu--horizontal > .el-menu-item {
  float: left;
  height: 48px;
  line-height: 48px;
  margin: 0;
  border-bottom: none;
  color: #333333;
  font-weight: 500;
  font-size: 16px;
}

.home-container >>> .el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: none;
  color: #FE273B;
}

.home-container >>> .el-menu--horizontal .el-menu-item:not(.is-disabled):hover {
  color: #999999;
}

.home-container >>> .el-menu.el-menu--horizontal {
  border-bottom: none;
}
</style>
<style scoped lang="scss">
.home-container {
  background: white;

  .home-top {
    background: url("~@/assets/img/home/background2.png") no-repeat;
    background-size: 100% 100%;
    height: 340px;
    width: 76rem;
    padding: 0px 18%;

    .top-content {
      text-align: center;

      p {
        font-size: 48px;
        color: #fff;
        margin-block-start: 0em;
        margin-block-end: 0em;
        padding-top: 85px;
      }
    }
  }

  .home-content {
    width: 76rem;
    padding: 0px 18%;
    background: #fff;
  }

  .fiexd-content {
    padding-left: 17%;
    position: fixed;
    top: 82px;
    background: white;
    z-index: 9999;
    width: 100%;
    border: 1px solid #DDDDDD;
  }

  .search-menu {
    position: fixed;
    width: 100%;
    padding: 17px 18%;
    top: 0px;
    background: white;
    z-index: 9999;
    display: inline-flex;

    .title-logo {
      color: #333333;
      font-size: 24px;
      font-weight: 500;
      padding-left: 20px;
      line-height: 46px;
    }

    .logo {
      background: url("~@/assets/img/home/矢量智能对象.png") no-repeat;
      width: 48px;
      height: 48px;
      background-size: 100% 100%;
    }

    .el-input__inner {
      background-color: #ffffff !important;
      border-radius: 8px 0px 0px 8px;
      border: 1px solid white;
      color: #333333;
      font-size: 16px;
      height: 55px;
      line-height: 55px;
      padding: 0 50px;
    }
  }

  .home-info {
    background: white;
    padding: 0 18% 0px 18%;
    width: 76rem;
  }
}
</style>
<style>
.el-popover {
  max-width: 56%;
  padding: 0px 30px 20px;
}

.el-button.is-round {
  border-radius: 20px;
  padding: 12px 0px;
  margin-bottom: 10px;
  width: 80px;
  color: #333333;
  background: #F1F1F1;
  border: 1px solid #F1F1F1;
  font-size: 16px;
  margin-left: 0px;
  margin-right: 10px;
}
</style>